import { ButtonHTMLAttributes, DetailedHTMLProps } from 'react';

export function ArrowButton({
    className,
    ...props
}: DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>) {
    return (
        <button
            {...props}
            type='button'
            className={
                'grid size-9 place-items-center round:rounded-lg border border-theme-outline bg-theme-950/70 text-theme-text/80 transition-all hover:border-theme-primary/45 hover:bg-theme-primary/10 hover:text-theme-text focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-theme-primary/20 active:bg-theme-primary/16 disabled:pointer-events-none disabled:opacity-40' +
                (props.disabled ? ' disabled' : '') +
                (className ? ' ' + className : '')
            }
        />
    );
}
